import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LstorageService } from '../common/lstorage.service';
import { LSkeys } from '../../configs/app.constants';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private currentLanguageSubject = new BehaviorSubject<string>('en');
  currentLanguage$ = this.currentLanguageSubject.asObservable();

  constructor(private lstorageService: LstorageService) {
    // Load language from localStorage if available
    const storedLanguage = this.lstorageService.getItem(LSkeys.SELECTED_LANGUAGE);
    if (storedLanguage) {
      this.currentLanguageSubject.next(storedLanguage);
    }
  }

  changeLanguage(language: string) {
    this.currentLanguageSubject.next(language);
    this.lstorageService.store(LSkeys.SELECTED_LANGUAGE, language);
  }

  // Expose a method to get the language from localStorage
  getStoredLanguage(): string | null {
    return this.lstorageService.getItem(LSkeys.SELECTED_LANGUAGE);
  }
}
